<template>
  <form @submit.prevent="submit">
    <div class="flex flex-wrap -mb-8 -mr-6 p-8">
      <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Name" />
      <text-input v-model="form.title" :error="form.errors.title" class="pb-8 pr-6 w-full lg:w-1/2" label="Title" />
      <text-input v-model="form.color" type="color" :error="form.errors.color" class="pb-8 pr-6 w-full lg:w-1/2" label="Color" style="height: 50px" />
      <select-input v-model="form.project_id"  :error="form.errors.project_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Project">
        <option :value="null" />
        <option v-for="project in projects" :key="project.id" :value="project.id">{{ project.name }}</option>
      </select-input>
      <select-input v-model="form.orientation" :error="form.errors.orientation" class="pb-8 pr-6 w-full lg:w-1/2" label="Orientation">
        <option value="landscape">Landscape</option>
        <option value="portrait">Portrait</option>
      </select-input>
    </div>
    <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
      <slot name="extra-actions"></slot>
      <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">{{ submitButtonText }}</loading-button>
    </div>
  </form>
</template>

<script>
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    TextInput,
    SelectInput,
    LoadingButton,
  },
  props: {
    form: Object,
    projects: Array,
    isTechnician: {
      type:Boolean,
      default:true,
    },
    isAdmin: {
      type:Boolean,
      default:true,
    },
    canSelectProject: {
      type:Boolean,
      default:false
    },
    submitButtonText: {
      type: String,
      default: 'Submit',
    },
    submit: {
      type: Function,
      required: true,
    },
  }
}
</script>
